import Question1 from './question1'
export default Question1
